import Title from "../home/Title";
import ResumeCard from "../resume/ResumeCard";

const Publications = () => {
    return (
        <section id="resume">
            <Title title="My" subTitle="Publications" />
            <div className="w-full grid grid-cols-3 px-8">
                <div className="col-span-9 md:col-span-4">
                    <ResumeCard
                        duration="2024"
                        title="Voice of Hearing and Speech Impaired People"
                        researchGateUrl='https://www.researchgate.net/publication/382494916'
                        ieeeUrl='https://ieeexplore.ieee.org/document/10593248'
                        subTitle="IEEE IC3SE-2024 Conference"
                        des="Published in 2024 International Conference on Communication, Computer Sciences and Engineering (IC3SE), Amity University, Greater Noida, India. DOI: 10.1109/IC3SE62002.2024.10593248"
                    />
                </div>
            </div>
        </section>
    );
};

export default Publications;
